import { useState } from "react";
import { useStation } from "../lib/station";
import { CaretDown, Buildings, Check } from "@phosphor-icons/react";
import { NavLink } from "react-router-dom";

export default function StationPicker() {
  const { stations, active, setActive } = useStation();
  const [open, setOpen] = useState(false);

  if (!active) return null;

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="station-picker-toggle"
        className="h-10 px-3 rounded-lg border border-white/[0.06] hover:border-white/20 flex items-center gap-2 max-w-[150px]"
      >
        <Buildings size={16} weight="bold" className="text-[#FF6B00] flex-shrink-0" />
        <span className="text-xs font-bold uppercase tracking-wider truncate">
          {active.name}
        </span>
        <CaretDown size={12} weight="bold" className="text-gray-400" />
      </button>

      {open && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setOpen(false)}
            aria-hidden
          />
          <div
            className="absolute right-0 mt-1 w-64 surface-elevated rounded-lg shadow-2xl z-50 overflow-hidden"
            data-testid="station-picker-menu"
          >
            <div className="px-3 py-2 text-[10px] uppercase tracking-[0.18em] text-gray-500 border-b border-white/[0.06]">
              Active Station
            </div>
            {stations.map((s) => (
              <button
                key={s.id}
                onClick={() => {
                  setActive(s.id);
                  setOpen(false);
                }}
                data-testid={`station-option-${s.id}`}
                className="w-full text-left px-3 py-3 flex items-center justify-between hover:bg-white/[0.04] tap-highlight-none"
              >
                <div>
                  <div className="text-sm font-bold text-white">{s.name}</div>
                  {s.address && (
                    <div className="text-[10px] text-gray-500">{s.address}</div>
                  )}
                </div>
                {s.id === active.id && (
                  <Check size={16} weight="bold" className="text-[#FF6B00]" />
                )}
              </button>
            ))}
            <NavLink
              to="/settings"
              onClick={() => setOpen(false)}
              data-testid="station-manage-link"
              className="block px-3 py-3 border-t border-white/[0.06] text-xs font-bold uppercase tracking-wider text-[#FF6B00] hover:bg-white/[0.04]"
            >
              + Manage Stations
            </NavLink>
          </div>
        </>
      )}
    </div>
  );
}
